import domReady from '@wordpress/dom-ready';

/**
 * 料金表ブロックの ⓘ ツールチップ。
 *
 * PC（pointer:fine）はCSSのみでホバー表示するが、タップ操作の端末では
 * ホバーが安定しないため、クリックで .is-active を付け外しして表示を制御する。
 */
domReady( () => {
	const triggers = document.querySelectorAll( '.pricing-table__info-trigger' );

	if ( ! triggers.length ) {
		return;
	}

	const closeAll = ( except ) => {
		document.querySelectorAll( '.pricing-table__info.is-active' ).forEach( ( info ) => {
			if ( info === except ) {
				return;
			}
			info.classList.remove( 'is-active' );
			const button = info.querySelector( '.pricing-table__info-trigger' );
			if ( button ) {
				button.setAttribute( 'aria-expanded', 'false' );
			}
		} );
	};

	triggers.forEach( ( trigger ) => {
		trigger.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			const info = trigger.closest( '.pricing-table__info' );
			if ( ! info ) {
				return;
			}
			const isActive = info.classList.contains( 'is-active' );
			closeAll( info );
			info.classList.toggle( 'is-active', ! isActive );
			trigger.setAttribute( 'aria-expanded', String( ! isActive ) );
		} );
	} );

	document.addEventListener( 'click', ( event ) => {
		if ( event.target.closest( '.pricing-table__info' ) ) {
			return;
		}
		closeAll();
	} );

	document.addEventListener( 'keydown', ( event ) => {
		if ( 'Escape' === event.key ) {
			closeAll();
		}
	} );
} );
